import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary text-white mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-xl font-bold mb-4 uppercase">Balaji Enterprises</h3>
            <p className="text-sm text-slate-300">
              Your trusted partner for industrial hardware solutions since 1995.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg font-bold mb-4 uppercase">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-slate-300 hover:text-secondary transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-sm text-slate-300 hover:text-secondary transition-colors">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-slate-300 hover:text-secondary transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg font-bold mb-4 uppercase">Contact Info</h4>
            <ul className="space-y-2">
              <li className="flex items-start space-x-2 text-sm text-slate-300">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span>Industrial Area, Sector 15, Mumbai, Maharashtra 400001</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-slate-300">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <span>+91 9876543210</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-slate-300">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <span>contact@balajienterprises.com</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg font-bold mb-4 uppercase">Business Hours</h4>
            <div className="flex items-start space-x-2 text-sm text-slate-300">
              <Clock className="h-4 w-4 mt-0.5 flex-shrink-0" />
              <div>
                <p>Monday - Saturday</p>
                <p>9:00 AM - 7:00 PM</p>
                <p className="mt-2">Sunday: Closed</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 text-center">
          <p className="text-sm text-slate-400">
            © 2024 Balaji Enterprises. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;